module.exports = {
    "name": "",
    "pinImageUrl": "",
    "iconImageUrl": "",
    "active": true
};